import React from "react";
import "./App.css";
import Header from "./components/Header";
import Credentials from "./components/Credentials";
import Services from "./components/Services";

import Footer from "./components/Footer";
import Contact from "./components/Contact";
import Studio from "./components/Studio";
import Gallery from "./components/Gallery";
import InteriorPackages from "./components/InteriorPackages";

function App() {
  return (
    <div className="App relative min-h-screen overflow-visible bg-transparent font-body text-text-color">
      <Header />
      <main id="main-content">
        <Studio />
        <Services />
        <InteriorPackages />
        <Credentials />
        <Gallery />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
